import { render, staticRenderFns } from "./OfertaDelete.vue?vue&type=template&id=1f46931a&scoped=true&"
import script from "./OfertaDelete.vue?vue&type=script&lang=js&"
export * from "./OfertaDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f46931a",
  null
  
)

export default component.exports